import { ActionsGridHelper } from '@components-clean/core/api-grid/helpers/actions-grid-helper';
import { BaseGridHelper } from '@components-clean/core/api-grid/helpers/base-grid-helper';
import { ControlsHubOoTGridHelper } from '@components-clean/core/api-grid/helpers/controls-hub-oot-grid-helper';
import { ControlsHubPanelGridHelper } from '@components-clean/core/api-grid/helpers/controls-hub-panel-grid-helper';
import { ControlsReviewLogHelper } from '@components-clean/core/api-grid/helpers/controls-review-log-grid-helper';
import { IGridHelper } from '@components-clean/core/api-grid/helpers/interfaces';
import { ObservationGridHelper } from '@components-clean/core/api-grid/helpers/observation-grid-helper';
import { ReviewLogGridHelper } from '@components-clean/core/api-grid/helpers/review-log-grid-helper';
import { SmActionsGridHelper } from '@components-clean/core/api-grid/helpers/subject-monitoring/actions-grid-helper';
import { SmObservationsGridHelper } from '@components-clean/core/api-grid/helpers/subject-monitoring/observations-grid-helper';
import { SmReviewLogsGridHelper } from '@components-clean/core/api-grid/helpers/subject-monitoring/review-logs-grid-helper';
// eslint-disable-next-line max-len
import { SubjectReviewActivityLogGridHelper } from '@components-clean/core/api-grid/helpers/subject-monitoring/subject-review-activity-log-grid-helper';
import { CustomCells } from '@components-clean/core/grid/custom-cell';
import { ApiGridParams } from '@interfaces/central-monitoring';
import { ObservationType } from '@interfaces-clean/observations.interface';

export const getGridHelper = (params: ApiGridParams, customCells: CustomCells): IGridHelper => {
    switch (params.grid) {
        case 'SubjectReviewActivityLog':
            return new SubjectReviewActivityLogGridHelper(customCells);
        case 'Observations':
            return new ObservationGridHelper(customCells);
        case 'ReviewLog':
            if (params.level === ObservationType.Controls)
                return new ControlsReviewLogHelper(params.isChild, customCells);
            return new ReviewLogGridHelper(params.isChild, customCells);
        case 'Actions':
            return new ActionsGridHelper();
        case 'ControlsHubOoTGrid':
            return new ControlsHubOoTGridHelper(customCells);
        case 'ControlsHubPanelGrid':
            return new ControlsHubPanelGridHelper(customCells);
        case 'SmActions':
            return new SmActionsGridHelper(customCells);
        case 'SmObservations':
            return new SmObservationsGridHelper(customCells);
        case 'SmReviewLog':
            return new SmReviewLogsGridHelper(params.isChild, customCells);
        case 'DataTable':
        default:
            return new BaseGridHelper(params, customCells);
    }
};
